import _get from 'lodash/get';
import { ColorEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import AssetFieldNames from '@lib/enums/fieldNames/assetCategoryFieldNames';

export default function getPreparedAssetCategoryDataFromValues(values: Values) {
  return {
    name: _get(values, AssetFieldNames.Name, '') as string,
    color: _get(values, `${AssetFieldNames.Color}.value`, '') as ColorEnum,
    prefix: _get(values, AssetFieldNames.Prefix, '') as string,
  };
}
